import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Measurement, MeasurementItem } from '/@/app/views/LabTestView/Measurement';
import { observer } from 'mobx-react';

export const SectionItem = styled(Box)(({ theme }) => ({
    ...theme.typography.body2,
    //
    padding: 0,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
    },
    //
    textAlign: 'center',
    color: theme.palette.text.secondary,

    // make it look simple on mobile, but use cards on wide screens
    [theme.breakpoints.up('md')]: {
        backgroundColor: '#f5f7fb',
        borderRadius: theme.shape.borderRadius * 1.5,
        padding: theme.spacing(2),
    },
}));



export const Section = observer(({ section }) => {
    let header = null;
    if (section.section_name) {
        header = <Typography variant="h5" sx={{padding: "10px 0"}}>{section.section_name}</Typography>;
    }
    return (
        <>
            {header}
            <Grid container spacing={2} sx={{
                paddingTop: 2
            }}>
                {section.measurements.map((mState, index) => (
                    <Grid item xs={12} md={6} key={index} sx={{
                        // reduce the space between items
                        paddingTop: "0!important",
                        // content to bottom,
                        // so it will align with neighboring items on wide screens
                        display: 'flex',
                        alignItems: 'stretch',
                        justifyContent: 'center',
                        flexFlow: 'column nowrap',
                    }}>
                        <MeasurementItem>
                            <Measurement mState={mState} />
                        </MeasurementItem>
                    </Grid>
                ))}
            </Grid>
        </>
    )
})
